import i18n from 'src/i18n'
import { StationVariable } from './StationVariable'

export enum HourlyStationVariableID {
  TEMPERATURE = 'TA',
  HUMIDITY = 'HR',
  WIND_SPEED = 'VV',
  WIND_DIRECTION = 'DV',
  PRECIPITATION = 'PREC',
  PRESSURE = 'PRES_NMAR'
}

export class HourlyStationVariable extends StationVariable {
  constructor(public id: HourlyStationVariableID) {
    super()
  }

  getLabel() {
    switch (this.id) {
      case HourlyStationVariableID.TEMPERATURE:
        return i18n.t('station.temperature')
      case HourlyStationVariableID.HUMIDITY:
        return i18n.t('station.humidity')
      case HourlyStationVariableID.WIND_SPEED:
        return i18n.t('station.wind_speed')
      case HourlyStationVariableID.PRECIPITATION:
        return i18n.t('station.precipitation')
      case HourlyStationVariableID.PRESSURE:
        return i18n.t('station.pressure')
    }
  }

  getIcon() {
    switch (this.id) {
      case HourlyStationVariableID.TEMPERATURE:
        return 'temperature'
      case HourlyStationVariableID.HUMIDITY:
        return 'humidity'
      case HourlyStationVariableID.WIND_SPEED:
        return 'wind'
      case HourlyStationVariableID.PRECIPITATION:
        return 'rain'
      case HourlyStationVariableID.PRESSURE:
        return 'pressure'
    }
  }

  getDecimals() {
    switch (this.id) {
      case HourlyStationVariableID.PRESSURE:
        return 0
      default:
        return 1
    }
  }

  getUnits() {
    switch (this.id) {
      case HourlyStationVariableID.TEMPERATURE:
        return 'ºC'
      case HourlyStationVariableID.HUMIDITY:
        return '%'
      case HourlyStationVariableID.WIND_SPEED:
        return 'km/h'
      case HourlyStationVariableID.PRECIPITATION:
        return 'mm'
      case HourlyStationVariableID.PRESSURE:
        return 'hPa'
      default:
        return ''
    }
  }

  getScaleColors() {
    switch (this.id) {
      case HourlyStationVariableID.TEMPERATURE:
        return StationVariable.ScaleValues_Temperature
      case HourlyStationVariableID.HUMIDITY:
        return StationVariable.ScaleValues_Humidity
      case HourlyStationVariableID.WIND_SPEED:
        return StationVariable.ScaleValues_WindSpeed
      case HourlyStationVariableID.PRECIPITATION:
        return StationVariable.ScaleValues_Precipitation
      case HourlyStationVariableID.PRESSURE:
        return StationVariable.ScaleValues_Pressure
      default:
        return []
    }
  }
}
